<li class="blog-card" [class.not-home]="!isHome">
  <ng-container
    *ngTemplateOutlet="
      blogTemplate;
      context: { isArabic: currentLang === ApplicationLanguages.Ar }
    "
  >
  </ng-container>

  <ng-template #blogTemplate let-isArabic="isArabic">
    <div class="blog-data-container">
      <div>
        <img
          loading="lazy"
          *ngIf="blog.img"
          class="blog-img"
          [src]="blog.img"
          [alt]="
            currentLang == ApplicationLanguages.Ar ? blog.titleAr : blog.titleEn
          "
        />
        <video *ngIf="blog.video" class="blog-img" controls>
          <source [src]="blog.video" />
        </video>

        <div class="blog-data" [class.arabic-only-blog]="blog.isArabicOnly">
          <h3>
            {{
              currentLang == ApplicationLanguages.Ar
                ? blog.titleAr
                : blog.titleEn
            }}
          </h3>
          <div
            class="html-content"
            [innerHTML]="
              isArabic ? this.blog.shortDescAr : this.blog.shortDescEn
            "
          ></div>
        </div>
      </div>

      <p class="blog-date">
        {{
          currentLang == ApplicationLanguages.Ar
            ? (blog.date | date : "dd MMM yyyy" : "" : ApplicationLanguages.Ar)
            : (blog.date | date : "dd MMM yyyy")
        }}
      </p>
    </div>
  </ng-template>
</li>
